import React from 'react';
import Icon from '../../common/Icons';
import { ReceptionEmptyState } from '../../receptionist/ui';
import {
  classifyNursingQueueItem,
  getQueueBucketLabel,
  isQueueItemDone
} from '../utils/nurseQueueFilters';
import { NURSE_COPY } from '../nurseCopy';

const Q = NURSE_COPY.QUEUE;

function formatWhen(dateString, fullDate) {
  if (!dateString) return '—';
  const d = new Date(dateString);
  if (fullDate) {
    return d.toLocaleString('fr-FR', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export default function NurseFileQueueList({
  rows = [],
  onOpen,
  doneView = false,
  emptyTitle,
  emptyDescription,
  listAriaLabel = Q.LIST_ARIA
}) {
  if (!rows.length) {
    return (
      <div className="px-3 py-4">
        <ReceptionEmptyState title={emptyTitle} description={emptyDescription} />
      </div>
    );
  }

  return (
    <div className="recv-queue-list-wrap nr-file-list-wrap">
      <div className="recv-queue-list nr-file-list" role="list" aria-label={listAriaLabel}>
        <div className="recv-queue-list__head nr-file-list__head" aria-hidden="true">
          <span className="recv-queue-list__cell recv-queue-list__cell--patient">{Q.COL_PATIENT}</span>
          <span className="recv-queue-list__cell recv-queue-list__cell--line">{Q.COL_STATUS}</span>
          <span className="recv-queue-list__cell recv-queue-list__cell--consult" aria-hidden />
        </div>
        {rows.map((consultation) => {
          const bucket = classifyNursingQueueItem(consultation);
          const isDone = isQueueItemDone(consultation);
          const patientName = consultation.patient_name || 'Patient';
          const patientMeta = [consultation.member_matricule, consultation.member_company_name]
            .filter(Boolean)
            .join(' · ');

          return (
            <article
              key={consultation.id}
              className={`recv-queue-row nr-file-row${isDone ? ' nr-file-row--done' : ''}`}
              role="listitem"
            >
              <button
                type="button"
                className="nr-file-row__open"
                onClick={() => onOpen?.(consultation)}
                aria-label={`${isDone ? Q.ACTION_VIEW : Q.ACTION_OPEN} — ${patientName}`}
              >
                <span className="recv-queue-row__patient recv-queue-list__cell recv-queue-list__cell--patient">
                  <span className="recv-queue-row__time font-monospace">
                    {formatWhen(consultation.consultation_date, doneView)}
                  </span>
                  <span className="recv-queue-row__name">{patientName}</span>
                  {patientMeta ? (
                    <span className="recv-queue-row__meta">{patientMeta}</span>
                  ) : null}
                </span>
                <span className="recv-queue-row__line recv-queue-list__cell recv-queue-list__cell--line">
                  <span className={`nr-queue-status nr-queue-status--${bucket}`}>
                    {getQueueBucketLabel(bucket)}
                  </span>
                </span>
                <span className="recv-queue-row__consult recv-queue-list__cell recv-queue-list__cell--consult">
                  <span className="nr-file-row__chevron" aria-hidden>
                    <Icon name="chevronRight" size={18} />
                  </span>
                </span>
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
}
